<template>
  <div id="header">
    <router-link to='/' class="btn">Home</router-link>
    <router-link to='/Video' class="btn">Video</router-link>
    <router-link to='/Album' class="btn">Albums</router-link>
    <a href="https://www.facebook.com/mortormetal/" target="_blank" class="btn"><img src="../assets/facebook-logo.png" alt="facebook" id="facebook-logo"></a>
    <a href="http://mortor.bandcamp.com" target="_blank" class="btn"><img src="../assets/Bandcamp_Logo.png" alt="Bandcamp" id="bandcamp-logo"></a>
    <a href="https://cdnrecords.com/shop/mortor-burn-up-the-dead/" target="_blank" class="btn"><img src="../assets/CDN_RECORD.jpg" alt="CDN Records" id="cdnrecords-logo"></a>
  </div>
</template>

<script>
export default {
  name: 'Menu'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a:link, a:visited {
    /* background-color: #eeeeee; */
    opacity: 0.8;
    color: #ffffff;
    padding: 0.5vw 0.5vw;
    text-align: center; 
    text-decoration: none;
    display: inline-block;
}

a:active {
    /* background-color: red; */
    color: red;
}

a:hover {
    /* background-color: #111111; */
    color: #f44336;
    opacity: 1.0;
    transition: opacity 1s;
    transition: color 1s;
}

.btn{
    width: 15%;
}

#header{
    margin-bottom: 2vh;
    background: linear-gradient(to top, rgba(0,0,0,0.1), rgba(0,0,0,1));
    overflow: hidden;
}

#facebook-logo{
    width: 18vh;
    padding-bottom: 0.0vh;
}

#bandcamp-logo{
    width: 18vh;
}

#cdnrecords-logo{
    width: 12vh;
}

@media only screen and (max-width: 450px) {
    .btn{
        width: 100%;
    } 
}
 
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue